export default __webpack_public_path__ + "static/media/navigation-left-arrow.d8abb2a7.svg";